// Unit converter - length, mass, temperature, area, volume, speed, data, time.
import { announceSoon, el, input, sel, field, wrap } from "./ui.js";

// Factor maps convert TO a base unit. Temperature is special-cased below.
const UNITS = {
	Length: { base: "m", units: { Kilometre: 1000, Metre: 1, Centimetre: 0.01, Millimetre: 0.001, Mile: 1609.344, Yard: 0.9144, Foot: 0.3048, Inch: 0.0254, "Nautical mile": 1852 } },
	Mass: { base: "kg", units: { Tonne: 1000, Kilogram: 1, Gram: 0.001, Milligram: 1e-6, Pound: 0.45359237, Ounce: 0.0283495231, Stone: 6.35029318 } },
	Area: { base: "m²", units: { "Square km": 1e6, Hectare: 1e4, "Square metre": 1, "Square foot": 0.092903, "Square inch": 0.00064516, Acre: 4046.8564224 } },
	Volume: { base: "L", units: { Litre: 1, Millilitre: 0.001, "Cubic metre": 1000, Gallon: 3.785411784, Quart: 0.946352946, Pint: 0.473176473, Cup: 0.2365882365, "Fluid ounce": 0.0295735296 } },
	Speed: { base: "m/s", units: { "Metre/sec": 1, "Km/hour": 0.277777778, "Mile/hour": 0.44704, Knot: 0.514444444, "Foot/sec": 0.3048 } },
	Data: { base: "byte", units: { Bit: 0.125, Byte: 1, Kilobyte: 1024, Megabyte: 1048576, Gigabyte: 1073741824, Terabyte: 1099511627776 } },
	Time: { base: "s", units: { Second: 1, Minute: 60, Hour: 3600, Day: 86400, Week: 604800, Millisecond: 0.001 } },
	Temperature: { base: "°C", units: { Celsius: "C", Fahrenheit: "F", Kelvin: "K" } },
};

function toBase(cat, unit, v) {
	if (cat !== "Temperature") return v * UNITS[cat].units[unit];
	const k = UNITS[cat].units[unit];
	return k === "C" ? v : k === "F" ? (v - 32) * 5 / 9 : v - 273.15; // -> Celsius
}
function fromBase(cat, unit, v) {
	if (cat !== "Temperature") return v / UNITS[cat].units[unit];
	const k = UNITS[cat].units[unit];
	return k === "C" ? v : k === "F" ? v * 9 / 5 + 32 : v + 273.15;
}

export function converter(root) {
	const s = wrap(root); s.classList.add("rv-conv");
	const cats = Object.keys(UNITS);
	const catSel = sel(cats.map((c) => [c, c]), "Length");
	catSel.setAttribute("aria-label", "Kind of unit");
	const fromSel = sel([]); const toSel = sel([]);
	const amount = input("number", { value: "1" });
	const result = el("input", "rv-tinput rv-conv-result"); result.readOnly = true;

	function fillUnits() {
		const cat = catSel.value;
		const names = Object.keys(UNITS[cat].units);
		[fromSel, toSel].forEach((selEl, i) => {
			selEl.textContent = "";
			names.forEach((n) => { const o = el("option", null, n); o.value = n; selEl.appendChild(o); });
			selEl.value = names[i === 0 ? 0 : Math.min(1, names.length - 1)];
		});
	}
	function compute() {
		const cat = catSel.value;
		const v = parseFloat(amount.value);
		if (Number.isNaN(v)) { result.value = ""; return; }
		const base = toBase(cat, fromSel.value, v);
		const r = fromBase(cat, toSel.value, base);
		result.value = String(+r.toPrecision(10));
		announceSoon(amount.value + " " + fromSel.selectedOptions[0]?.textContent + " is " + result.value + " " + toSel.selectedOptions[0]?.textContent);
	}
	function swap() { const a = fromSel.value; fromSel.value = toSel.value; toSel.value = a; compute(); }

	catSel.addEventListener("change", () => { fillUnits(); compute(); });
	[fromSel, toSel, amount].forEach((e) => e.addEventListener("input", compute));

	const swapBtn = el("button", "rv-tbtn rv-conv-swap", "⇄"); swapBtn.type = "button"; swapBtn.title = "Swap"; swapBtn.setAttribute("aria-label", "Swap units"); swapBtn.addEventListener("click", swap);

	s.append(
		field("Category", catSel),
		el("div", "rv-conv-grid"),
	);
	const grid = s.querySelector(".rv-conv-grid");
	grid.append(field("Amount", amount), field("From", fromSel), swapBtn, field("Result", result), field("To", toSel));
	fillUnits(); compute();
}
